import React, {useRef} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {useClampText} from 'components/ProductSnippetNew/hooks/useClampText';
import {Properties} from 'components/ProductSnippetNew/components/ProductSnippetContent/Information/Properties';
import CustomRoutingLink from 'components/CustomRoutingLink';

type TInformationProps = Pick<IProductSnippet, 'title' | 'description' | 'properties' | 'url' | 'isCompact'> &
    Pick<IProductSnippet['price'], 'badges'> &
    Pick<IProductSnippet['analytics'], 'onProductClick'> & {pixelOverflow: number};

export const Information = (props: TInformationProps) => {
    const {title, pixelOverflow, properties, url, onProductClick, isCompact = false} = props;

    const titleRef = useRef<HTMLDivElement>(null);
    const descriptionRef = useRef<HTMLDivElement>(null);
    const rootRef = useRef<HTMLDivElement>(null);

    useClampText({
        rootRef,
        titleRef,
        descriptionRef,
        pixelOverflow,
        desc: properties.asString,
    });

    return (
        <div ref={rootRef} className={style.root} data-skeleton-item={true}>
            <CustomRoutingLink href={url} onClick={onProductClick}>
                <Typography
                    ref={titleRef}
                    className={style.title}
                    variants={{DT: 'body-16-r', TB: 'body-16-r', MB: 'label-14-r'}}
                >
                    {title}
                </Typography>
            </CustomRoutingLink>
            {!isCompact && (
                <div ref={descriptionRef} className={style.description}>
                    <Properties {...properties} />
                </div>
            )}
        </div>
    );
};
